module.exports = __webpack_public_path__ + "static/img/s-mi-6.7650f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-mi-6.png
// module id = qn/8
// module chunks = 1